import OadpCardBulletHeader from './oadp-card-bullet-header';
export default OadpCardBulletHeader;
